import { CommentEndpoints } from 'src/client/comment/constants'
import { Loading } from 'src/components'
import { useHotRequest } from '@hotmart-org-ca/hot-club-http/client/hooks'
import { APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES } from 'src/config/request/hotClubHttp'
import { DEFAULT_CACHE_CONFIG } from 'src/services/constants'
import { PublicationEndpoints } from 'src/client/publication/constants'
import { AudioPreviewContent } from '../audioPreviewContent'
import { AudioPreviewProps } from './audioPreview.types'
import { CustomAudioPreview } from './audioPreview.styles'

const AudioPreview = ({
  postId,
  isPublication = false,
  className = '',
  componentName
}: AudioPreviewProps) => {
  const url = isPublication
    ? PublicationEndpoints.getPostsAudio(postId)
    : CommentEndpoints.getCommentAudio(postId)

  const { data, isLoading: isLoadingMedia } = useHotRequest<{ mediaUrl: string }>(url, {
    cacheKey: [url],
    instanceName: APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES.API_COMMUNITY_GATEWAY,
    params: {
      redirect: false
    },
    queryOptions: {
      ...DEFAULT_CACHE_CONFIG
    }
  })

  const postMediaSrc = data?.mediaUrl as string

  return (
    <CustomAudioPreview data-test="audio-preview" className={className}>
      {isLoadingMedia ? (
        <div className="_w-full _d-flex _align-items-center _justify-content-center">
          <Loading />
        </div>
      ) : (
        <AudioPreviewContent
          src={postMediaSrc}
          isPublication={isPublication}
          componentName={componentName}
        />
      )}
    </CustomAudioPreview>
  )
}

export default AudioPreview
